




























































import { computed, defineComponent, ref } from "@vue/composition-api";
import { Announcement } from "@scrile/api-provider/dist/api/AnnouncementsProvider";
import { BlockingStatus } from "@scrile/api-provider/dist/api/BlockingStatusProvider";
import { MessageThread } from "@scrile/api-provider/dist/api/MessageThreadsProvider";
import { Subscription } from "@scrile/api-provider/dist/api/SubscriptionProvider";
import useAuthUser from "@/hooks/useAuthUser";
import { $t } from "@/lib/i18nHelpers";
import { getThreadOpponentId } from "@/lib/opponentIdHelper";
import { BaseMenuItem } from "@/types";
import BaseIconButton from "@/components/BaseIconButton";
import BaseMenu from "@/components/BaseMenu";
import BasePage from "@/components/BasePage";
import InfiniteScroll from "@/components/InfiniteScroll";
import PageTitle from "@/components/PageTitle";
import MessageThreadAnnouncements from "./MessageThreadAnnouncements";
import MessageThreadItem from "./MessageThreadItem.vue";
import MessageThreadsEmptyView from "./MessageThreadsEmptyView.vue";
import MessageThreadsHideConfirm from "./MessageThreadsHideConfirm.vue";
import MessageThreadsSort from "./MessageThreadsSort";
import { MessageSortTypeEnum } from "../types";

export default defineComponent({
  name: "MessageThreadsView",
  components: {
    MessageThreadAnnouncements,
    MessageThreadsHideConfirm,
    BaseIconButton,
    InfiniteScroll,
    MessageThreadsEmptyView,
    BasePage,
    BaseMenu,
    PageTitle,
    MessageThreadItem,
    MessageThreadsSort,
  },
  props: {
    loading: { type: Boolean, required: true },
    allowMassMessage: { type: Boolean, required: true },
    allowMassMessageStat: { type: Boolean, required: true },
    messageThreadList: { type: Array as () => MessageThread[], required: true },
    subscribersList: { type: Object as () => Record<string, Subscription>, required: true },
    authUserId: { type: String, required: true },
    scroll: { type: Boolean, required: true },
    blockingStatus: { type: Array as () => BlockingStatus[], required: true },
    currentSortItem: { type: Number as () => MessageSortTypeEnum, required: true },
    announcements: { type: Array as () => Announcement[], required: true },
    hasUnreadAnnouncement: { type: Boolean, default: false },
    canManageThreads: { type: Boolean, required: true },
  },
  setup(props, { emit }) {
    const { authorities } = useAuthUser();

    const activeDeleteThread = ref<MessageThread | null>(null);
    const activeHideThread = ref<MessageThread | null>(null);

    const showConfirm = computed(() => !!activeDeleteThread.value || !!activeHideThread.value);
    const emptyThreads = computed(() => !props.loading && props.messageThreadList.length === 0);
    const blockStatusList = computed<Record<string, boolean>>(() => {
      const list: Record<string, boolean> = {};
      props.blockingStatus.forEach(s => (list[s.blockedUserId] = true));
      return list;
    });
    const menuItems = computed<BaseMenuItem[]>(() => {
      const items = [];
      if (props.allowMassMessage) {
        items.push({
          name: "sendMassMessage",
          text: $t("Send Mass message"),
          prependIcon: "sci-send",
        });
      }
      if (props.allowMassMessageStat) {
        items.push({
          name: "statistics",
          text: $t("Statistics"),
          prependIcon: "sci-bar",
        });
      }
      return items;
    });

    const getSubscriptionCost = (id: string) => {
      return props.subscribersList[id]?.amount ?? 0;
    };
    const getBlockStatus = (ids: string[]): boolean => {
      const opponentId = getThreadOpponentId(ids, props.authUserId);
      return opponentId ? blockStatusList.value[opponentId] ?? false : false;
    };

    const onHideThread = () => {
      if (activeHideThread.value) emit("hideThread", activeHideThread.value);
      activeHideThread.value = null;
    };
    const onDeleteThread = () => {
      if (activeDeleteThread.value) emit("deleteThread", activeDeleteThread.value);
      activeDeleteThread.value = null;
    };
    const onCancel = () => {
      activeHideThread.value = null;
      activeDeleteThread.value = null;
    };

    return {
      authorities,
      showConfirm,
      emptyThreads,
      menuItems,
      activeDeleteThread,
      activeHideThread,
      getBlockStatus,
      getSubscriptionCost,
      onHideThread,
      onDeleteThread,
      onCancel,
    };
  },
});
